// extracted by mini-css-extract-plugin
export default {"main-holder":"style_main-holder__o2CfC","footer-box-main":"style_footer-box-main__CPkQX","container":"style_container__qOcII","content":"style_content__LqpFS"};